import { ArticleDto, ArticleHotNewsDto } from "../dto/article.dto";
import axios from "../utils/axios";
import { ApiInterface } from "./api.interface";

class ArticlesApi extends ApiInterface {
  constructor() {
    super("tracker");
  }

  public async getByUrl(url: string): Promise<ArticleDto> {
    return await axios.get(
      `${this.rootEndpoint}/by-url?url=${encodeURIComponent(url)}`
    );
  }

  public async readed(id: string, questId?: string): Promise<ArticleDto> {
    return await axios.post(
      `${this.rootEndpoint}/${id}/readed?questId=${questId}`
    );
  }

  public async claim(id: string, questId?: string): Promise<ArticleHotNewsDto> {
    return await axios.post(
      `${this.rootEndpoint}/${id}/claim?questId=${questId}`
    );
  }
}

export const articlesApi = new ArticlesApi();
